import { cn } from "@/lib/utils"

interface ReviewStatusBadgeProps {
  status: "Pending" | "Approved" | "Rejected"
}

const statusStyles: Record<string, string> = {
  Pending: "bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-400",
  Approved: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-400",
  Rejected: "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400",
}

const statusDotStyles: Record<string, string> = {
  Pending: "bg-amber-500",
  Approved: "bg-emerald-500",
  Rejected: "bg-gray-400",
}

export function ReviewStatusBadge({ status }: ReviewStatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
        statusStyles[status],
      )}
    >
      <span
        className={cn("h-1.5 w-1.5 rounded-full", statusDotStyles[status])}
      />
      {status}
    </span>
  )
}
